<template>
  <v-container class="pa-5" min-height="25vh">

    <v-card-title>
      {{ $t('club.reg.add_representant') }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t('club.reg.add_representant_info') }}
    </v-card-subtitle>
    

    <v-form ref="existingForm" @submit.prevent="registerExistingUser">
      <v-row>
        <!-- Vyhledání v databázi a vyplění polí -->
        <v-col cols="12" md="5">
          <v-autocomplete
          v-model="selectedAccId"
          :items="Accounts"
          :item-title="getFullName"
          item-value="account_id"
          :label="$t('club.reg.select_account')"
          :loading="isLoading"
          no-data-text="club.reg.no_unassigned_racers"
          clearable
          class="ma-1"
          hide-details
          density="comfortable"
          ></v-autocomplete>
        </v-col>

        <!-- <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
          <v-text-field v-model="account.email" label="Email" :rules="[rules.isValidEmail]" density="comfortable" />
        </v-col>
        <v-col cols="12" md="3" class="pb-0" v-show="selectedAccId">
          <v-text-field event_type v-model="account.birth_year" label="Rok narození" type="number" :rules="[rules.year]" density="comfortable" />
        </v-col>
        <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
          <v-text-field v-model="account.si_number" type="number" label="Číslo čipu" :rules="[rules.siNumber]" density="comfortable" />
        </v-col>
        <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
          <v-select v-model="account.gender" :items="sexOptions" label="Pohlaví" :rules="[rules.gender]" density="comfortable"/>
        </v-col> -->
        <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
          <v-select v-model="account.lvl" :items="lvlOptions" :label="$t('club.reg.choose_class')" :rules="[rules.lvl]" density="comfortable"/>
        </v-col>

      </v-row>
                      
      <v-btn v-if="selectedAccId" :loading="isLoading" class="mt-6" type="submit" color="primary" block :disabled="!isAccountFormValid">{{ $t('club.reg.add_member') }}</v-btn>
      <v-card-actions>
        <v-btn color="grey" class="mt-" @click="emit('close')">{{ $t('general.cancel') }}</v-btn>
      </v-card-actions>

    </v-form>


  </v-container>
</template>


<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import apiClient from '/api.js';
// import { useAuthStore } from '/auth.js';
// import CountrySelect from '@/components/shared/CountrySelect.vue';
// import { countryCodeMap } from "@/utils/countryCodes.js";
import { useRoute } from 'vue-router';
import { useSnackbarStore } from '@/stores/snackbarStore';
import { useI18n } from 'vue-i18n'

const props = defineProps({
  club: { type: Object, required: true }
});

const emit = defineEmits(['registered','close']);

  const { t } = useI18n()
const route = useRoute();
const snackbar = useSnackbarStore()

// const authStore = useAuthStore(); // Použití Auth Store

const isLoading = ref(false);

const lvlOptions = [
  { title: t('club.club_members.class_1'), value: '1' },
  { title: t('club.club_members.class_2'), value: '2' },
  { title: t('club.club_members.class_3'), value: '3' },
  { title: t('club.club_members.class_4'), value: '' },
]


// --- Logika pro step I ---
const Accounts  = ref([])
const selectedAccId = ref(null)

const account = ref({
  account_id: null,
  first_name: '',
  last_name:  '',
  email:      '',
  si_number:  '',
  birth_year: '',
  gender:     '',
  index:      '',
  country:    '',
  lvl:        '',
})

const clubShortCut = computed(() => route.params.id)

async function fetchAccounts() {
  if (!clubShortCut.value) return
  isLoading.value = true
  try {
    const resp = await apiClient.get('account/create/', {
      params: { club_shortcut: clubShortCut.value }
    })
    Accounts.value = resp.data
  } finally {
    isLoading.value = false
  }
}


// Získání prvních tří písmen z indexu a předvyplnění pole index
onMounted(() => {
  formData.value.index = clubShortCut.value;
  fetchAccounts()
});

const getFullName = item => `${item.last_name} ${item.first_name} (${item.account_id})`

const existingForm = ref(null);

// když uživatel vybere účet, předvyplň všechna pole
watch(selectedAccId, async account_id => {
  const u = Accounts.value.find(x => x.account_id === account_id)
  if (!u) return
  account.value.account_id = u.account_id
  account.value.first_name = u.first_name
  account.value.last_name  = u.last_name
  account.value.email      = u.email
  account.value.si_number  = u.si_number
  account.value.birth_year = u.birth_year
  account.value.gender     = u.gender
  account.value.lvl        = u.lvl
  existingForm.value.validate()
})


const isAccountFormValid = computed(() => {
  if (!selectedAccId.value) return false
  return (
    // rules.value.isValidEmail(account.value.email) === true &&
    // rules.value.siNumber(account.value.si_number) === true &&
    // rules.value.year(account.value.birth_year) === true &&
    // rules.value.gender(account.value.gender) === true &&
    rules.value.lvl(account.value.lvl) === true
  )
})

// Odeslání formuláře z dat získaných z účtu uživatele - přiřazení role
const registerExistingUser = async () => {

  if (!isAccountFormValid.value) {
    snackbar.error(t('club.reg.error_fields_invalid'))
    return
  }

  isLoading.value = true;

  if (account.value.lvl === '0') {
      account.value.lvl = ''; // Pokud je úroveň 0, nastavíme ji na prázdnou hodnotu
    }

  try {
    const response = await apiClient.post(`account/create/?account_id=${account.value.account_id}&international=true&club_id=${props.club.id}`, account.value);
    if (response.status === 201) {
    }
    snackbar.success(t('club.reg.add_representant_success'));
    emit('registered')
    emit('close')

  } catch (error) {
    console.error('Chyba při registraci uživatele:', error);
    if (error.response && error.response.data) {
      // Zde předpokládáme, že chybová zpráva je přímo v 'data' jako string nebo jako objekt s klíčem 'error'
      const errorMsg = error.response.data.error || t('club.reg.error_account_create');
      snackbar.error(Array.isArray(errorMsg) ? errorMsg.join(', ') : errorMsg);
    } else {
      snackbar.error(t('club.reg.error_account_assign'));
    }
  } finally {
    isLoading.value = false; 
  }
};


// Formulář pro kompletní registraci uživatele

const formData = ref({
  account_id: null,
  email: '',
  first_name: '',
  last_name: '',
  index: '',
  gender: '',
  birth_year: '',
  si_number: '',
  country: '',
  lvl: '',
});

const rules = computed(() => ({
  
    isValidEmail: value => (!value || /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) || t('rules.invalid_email'),
  year: value => (value && value >= 1900 && value <= new Date().getFullYear()) || t('rules.born_year_between'),
  siNumber: v => (!v || /^\d{4,7}$/.test(v)) || t('rules.si_range'),
  firstName: value => (value.trim() !== '') || t('rules.required'),
  last_name: value => (value.trim() !== '') || t('rules.required'),
  gender: value => (['M', 'F'].includes(value)) || t('rules.required'),
  lvl: v => ['1','2','3', ''].includes(v) || t('club.reg.choose_class'),
  }));



// const router = useRouter();


// const sexOptions = [{title: 'Muž', value: 'M'}, {title: 'Žena', value: 'F'}]
// const countryOptions = [{title: 'Česká republika', value: 'CZE'}] 


// Zabránění kliknutí na tlačítka registrovat, pokud chybí některé z polí 
// const isFormValid = computed(() => {
//   return rules.value.isValidEmail(formData.value.email) === true &&
//          rules.value.firstName(formData.value.first_name) === true &&
//          rules.value.last_name(formData.value.last_name) === true &&
//          rules.value.year(formData.value.birth_year) === true &&
//          rules.value.gender(formData.value.gender) === true &&
//          rules.value.siNumber(formData.value.si_number) === true &&
//          (!isInternational.value || rules.value.userIndexPart(userIndexPart.value) === true);
// });







</script>

<style scoped>



</style>
